export default "__VITE_ASSET__875272qj__"